import { withApplicationLayout } from 'hocs/withApplicationLayout';
import { getDefautServerProps } from 'server/getDefaultServerProps';
import { GetServerSidePropsImpl } from 'utils/server/getserversideprops';
import { GetServerSideProps } from 'next';
import { Playground } from 'modules/Playground/Playground';
import { withPlaygroundEnabled } from 'hocs/withPlaygroundEnabled';
import { FC } from 'react';
import { createCookieServerStorage } from 'utils/cookieStorage';
import { getFeaturedModels } from 'modules/Playground/api/getFeaturedModels';
import { ApiMultiModelResponse, ApiSingleModelResponse } from 'types/swagger/clarifai-api';
import { getModel } from 'modules/Playground/api/getModel';
import { splitByLastDoubleUnderscore } from 'modules/WorkflowV2/utils/splitByLastDoubleUnderscore';

interface PlaygroundServerProps {
  featuredModels: ApiMultiModelResponse;
  trackEventProps: {
    eventName: string;
  };
  selectedModel: ApiSingleModelResponse | Record<string, never>;
  query: {
    model?: string;
    user_id?: string;
    app_id?: string;
  };
}

const Index: FC<PlaygroundServerProps> = ({ featuredModels, selectedModel, query }) => {
  return <Playground query={query} selectedModelInfo={selectedModel} featuredModelInitialData={featuredModels} />;
};

export const getServerSideProps: GetServerSideProps<PlaygroundServerProps> = GetServerSidePropsImpl('PlaygroundPage', async ({ ctx }) => {
  const { req, res, params, query } = ctx;
  const defautServerProps = await getDefautServerProps({ params, req, res });
  const sessionToken = createCookieServerStorage(req, res).get('session_token');

  const featuredModels = await getFeaturedModels({
    sessionToken,
  });

  const modelQuery = query.model as string | undefined;
  const userId = query.user_id as string | undefined;
  const appId = query.app_id as string | undefined;

  const [modelId, modelVersionId] = splitByLastDoubleUnderscore(modelQuery);

  let selectedModel: ApiSingleModelResponse | Record<string, never> = {};

  if (modelQuery && modelId && modelVersionId && userId && appId) {
    try {
      selectedModel = await getModel({
        params: {
          userAppIdUserId: userId,
          userAppIdAppId: appId,
          modelId,
        },
        query: {
          version_id: modelVersionId,
        },
        sessionToken,
      });
    } catch (e) {
      // Handle error if needed
      console.error('Error fetching model version:', e);
    }
  }

  return {
    props: {
      ...defautServerProps,
      trackEventProps: {
        eventName: 'Playground Page Viewed',
      },
      featuredModels,
      selectedModel,
      query,
    },
  };
});

export default withApplicationLayout()(withPlaygroundEnabled(Index as FC));
